import { ParticipanteRequest } from "../models/participantes";
import { EliminarMandatarioDto, Mandatario } from "../models/mandatario";
import { createMandatario, deleteMandatario, getMandatario, updateMandatario } from "../services/servicesMandatarios";
import { Axios, AxiosResponse } from "axios";
import { useState } from "react";

export function useMandatarios() {

    const [mandatarioDefaultValues] = useState<Mandatario>({
        mutuoid: 0,
        rut: '',
        rutOriginal: '',
        apellidopaterno: '',
        apellidomaterno: '',
        nombres: '',
        direccion: '',
        ciudadId: '',
        comunaId: '',
        fechanacimiento: undefined,
        nacionalidad: '',
        profesion: '',
        estadocivil: '',
        tipo: 'P'
    });

    const obtenerMandatario = async (dataRequest: ParticipanteRequest): Promise<Mandatario> => {

        const resp: AxiosResponse = await getMandatario(dataRequest)
        const dataMandatario: Mandatario = await resp.data;

        return dataMandatario;

    }

    const actualizarMandatario = async (deudor: Mandatario): Promise<void> => {

        await updateMandatario(deudor);

    }

    const crearMandatario = async (deudor: Mandatario): Promise<void> => {

        await createMandatario(deudor);
    }

    const eliminarMandario = async (data: EliminarMandatarioDto) => {
        const resp: AxiosResponse = await deleteMandatario(data);
        return resp;
    }

    return {
        mandatarioDefaultValues,
        obtenerMandatario,
        actualizarMandatario,
        crearMandatario,
        eliminarMandario
    }
}

